<div class="scrn">

  <div *ngIf="bShowAllPatients" class="abs_center stout" [ngClass]="{stout_pls:isPhoneLS}">
    <div class="cct mt0">
      Patients
    </div>
    <div *ngIf="user_patients_keys.length>0" class="btnsyn">
      <k-button class="btn1" text="Show Caller Patients" background="#000" color="#fff" kzLib (click)="bShowAllPatients=false"></k-button>
    </div>
    <div class="patients">
      <div class="btn" *ngFor="let patient_id of patients_keys; let i = index" (click)="selPatient(patient_id)">
        <div class="abs_center">
          {{patients[patient_id].first_name}} {{patients[patient_id].last_name}}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!bShowAllPatients" class="abs_center stout" [ngClass]="{stout_pls:isPhoneLS}">
    <div *ngIf="user_patients" class="cct mt0">
      Caller Patients
    </div>
    <div class="btnsyn">
      <k-button class="btn1" text="Show all Patients" background="#000" color="#fff" kzLib (click)="bShowAllPatients=true"></k-button>
    </div>
    <div class="patients">
      <div class="btn" *ngFor="let patient_id of user_patients_keys; let i = index" (click)="selPatient(patient_id)">
        <div class="abs_center">
          {{user_patients[patient_id].first_name}} {{user_patients[patient_id].last_name}}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="prompt" class="abs_center addPatient">
    {{prompt}}
    <div class="btnsyn">
      <k-button class="btn1" text="Yes" background="#000" color="#fff" kzLib (click)="addUser()"></k-button>
      <k-button text="No" background="#fff" color="#F5423B" kzLib (click)="cancelAdd()"></k-button>
    </div>
  </div>
</div>
